import { all, call, put, takeEvery } from 'redux-saga/effects'
import { getSubscription as getSubscriptionAction } from './autoTopupActions'
import autoTopupService from './autoTopupService'
import { autoTopupActions } from './autoTopupSlice'

function getErrorMessage(error: any) {
  return {
    message: error instanceof Error ? error.message : String(error),
    status: error?.response?.status || null,
    statusText: error?.response?.statusText || null,
  }
}

export function* getSubscription() {
  try {
    const response = yield call(autoTopupService.getSubscription)
    const subscriptions = Array.isArray(response.data) ? response.data : []
    yield put(autoTopupActions.getSubscriptionSuccess(subscriptions))
  } catch (error) {
    yield put(autoTopupActions.getSubscriptionFailed(getErrorMessage(error)))
  }
}

export function* watchGetSubscription() {
  yield takeEvery(getSubscriptionAction.type, getSubscription)
}

export default function* autoTopupSaga() {
  yield all([watchGetSubscription()])
}
